import $ from 'jquery';
import Marionette from 'backbone.marionette';
import _ from 'underscore';
import Logger from '@component/common/src/util/Logger';
import Overlay from '@component/common/src/components/Overlay';
import TagManager from '@component/common/src/util/TagManagerUtil';
import ObjectUtil from '@component/common/src/util/ObjectUtil';
import '@core/vendor/radio.shim';
import universalLogger from '@core/util/universal-logger';

const PageApp = new Marionette.Application();

// override all coremetrics functions
Object.keys(window).forEach((item) => {
  if (item.startsWith('cm')) {
    window[item] = function CoreMetricAnFn() { };
  }
});

window.$ = $;
window.jQuery = $;

PageApp.isProd = () => document.location.hostname.endsWith('.macys.com') || document.location.hostname.endsWith('.bloomingdales.com');

// Read the bootstrap data rendered in the DOM from main.hbs
let bootStrapData = {};
try {
  bootStrapData = $('script[data-bootstrap="page/marketing-campaigns"]').length !== 0 ? JSON.parse($('script[data-bootstrap="page/marketing-campaigns"]').html()) : {};
} catch (e) {
  Logger.error('Failed bootstraping metadata: ', e);
}

if (bootStrapData.CLIENT_SIDE_LOGGING_KILLSWITCH) {
  universalLogger.initClientLogRecording();
}

PageApp.getMeta = (key) => {
  const meta = ObjectUtil.getChildProperty(PageApp.meta, key);
  return _.isUndefined(meta) ? '' : meta;
};

PageApp.launchErrorOverlay = () => {
  try {
    PageApp.channel.trigger('hideLoader');

    if (PageApp.errorOverlay) {
      PageApp.errorOverlay.open();
    } else {
      // eslint-disable-next-line import/no-dynamic-require
      const template = require(`./src/templates/partials/${process.env.ENTRY_POINT}/serviceError.hbs`);
      PageApp.errorOverlay = new Overlay({
        title: 'That wasn\'t supposed to happen...',
        dialogClass: 'errorOverlay',
        modal: true,
        closeOnClick: true,
      });
      PageApp.errorOverlay.setBody(template());
      PageApp.errorOverlay.open();
      $('#serviceError button, body').click(() => {
        PageApp.errorOverlay.close();
      });
    }
  } catch (e) {
    Logger.warn("Can't load error message: ", e);
  }
};


PageApp.on('start', () => {
  try {
    if ($('script[data-bootstrap="page/cwgl"]').length !== 0) {
      if (JSON.parse($('script[data-bootstrap="page/cwgl"]').html()).meta) {
        PageApp.meta = JSON.parse($('script[data-bootstrap="page/cwgl"]').html()).meta;
      } else {
        PageApp.meta = {};
      }
    }
  } catch (e) {
    Logger.log('Error:', e, 'parsing page data-bootstrap script block html as JSON.');
  }

  // https://confluence.federated.fds/display/CAPCE/Adobe+Analytics
  $('#campaign').on('mouseenter', '*[data-lid]', (event) => {
    // event.stopPropagation();
    let isAChildAnchorTag;
    let masterHref;
    if ($(event.currentTarget).find('a:first').attr('href')) {
      masterHref = $(event.currentTarget).find('a:first').attr('href');
      isAChildAnchorTag = true;
    } else {
      masterHref = $(event.currentTarget).attr('href');
      isAChildAnchorTag = false;
    }

    let href = masterHref.split('#')[0];
    // to maintain conventions need to clean the jump link off the href and then re append it at the end
    const fragmentIdentifier = masterHref.split('#')[1];
    if (!masterHref.startsWith('#')) {
      // do not replace a hardcoded lid query parameter
      if (href.indexOf('lid=') === -1) {
        const tempValue = $(event.currentTarget).find('a:first').attr('data-lid') || $(event.currentTarget).attr('data-lid');
        const adobeAnalyticsValue = tempValue.toUpperCase();
        let analyticsTagPrefix = '';

        // is there a query parameter on the link
        if (href.indexOf('?') !== -1) {
          analyticsTagPrefix = '&lid=';
          href += `${analyticsTagPrefix}${adobeAnalyticsValue}`;
        } else {
          analyticsTagPrefix = '?lid=';
          href += `${analyticsTagPrefix}${adobeAnalyticsValue}`;
        }
      }
      // if the href has changed, update it
      if (href !== masterHref.split('#')[0]) {
        if (fragmentIdentifier) {
          // adds back the jump link
          href += `#${fragmentIdentifier}`;
        }
        if (isAChildAnchorTag) {
          $(event.currentTarget).find('a:first').attr('href', href);
        } else {
          $(event.currentTarget).attr('href', href);
        }
      }
    }
  });


  // https://confluence.federated.fds/display/CAPCE/Adobe+Analytics
  const allLinkTrackElements = Array.from(document.querySelectorAll('[data-linktrack]'));
  allLinkTrackElements.forEach((element) => {
    element.addEventListener('click', (event) => {
      const nonAnchorLinkTrackValue = event.currentTarget.dataset.linktrack;
      // customtags all needs json object example
      // {&quot;site_action&quot;:&quot;cc apply now start&quot;}
      const customTags = event.currentTarget.dataset.customtags;
      let linkTag = {};
      if (customTags) {
        linkTag = JSON.parse(customTags);
      }
      linkTag.link_name = nonAnchorLinkTrackValue;

      TagManager.fireTag('link', linkTag);
    }, false);
  });
});


export default PageApp;
